import React from 'react';
import { useMessageContext, MessageSimple } from 'stream-chat-react';
import { DateTime } from 'luxon';
import { MessageEditedAt, MessageWrapper } from './styled';

function CustomMessage(props: any) {
	const { message, isMyMessage } = useMessageContext();

	const editedAt = message.message_text_updated_at
		? DateTime.fromISO(message.message_text_updated_at).setZone('local').toFormat('dd.MM h:mm a')
		: null;

	const messageActions = isMyMessage()
		? ['delete', 'edit', 'quote', 'react']
		: ['flag', 'mute', 'quote', 'react', 'markUnread'];

	return (
		<MessageWrapper>
			<MessageSimple
				message={message}
				{...props}
				messageActions={messageActions}
			/>
			{editedAt && !message.deleted_at && (
				<MessageEditedAt isMyMessage={isMyMessage()}>
					{!isMyMessage() ? <b>{message?.user?.name}</b> : ''} Edited at {editedAt}
				</MessageEditedAt>
			)}
		</MessageWrapper>
	);
}

export default CustomMessage;
